/* Discipline Club LIVE for the store.
   Real numbers only, straight from the Discipline Hub. Men appear as initials. No weights per man.
   Walk-in (home, once per visit), live strip, word-by-word hero, results slider, live shirt count, scroll reveals. */
(function () {
  "use strict";
  var HUB = "https://hub.disciplinecoach.com/api/public/live";
  var doc = document, html = doc.documentElement;
  var editor = /in-theme-editor/.test(html.className) || !!(window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var live = null, listeners = [];

  function fmt(n) { return Number(n || 0).toLocaleString("en-US"); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function ago(iso) {
    var m = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 60000));
    if (!isFinite(m)) return "";
    if (m < 1) return "just now"; if (m < 60) return m + " min ago";
    var h = Math.round(m / 60); return h < 24 ? h + (h === 1 ? " hr ago" : " hrs ago") : "yesterday";
  }
  function newest(list) { return (list || []).slice().sort(function (a, b) { return Date.parse(b.at || 0) - Date.parse(a.at || 0); }); }
  function countUp(el, to, ms) {
    if (!el) return; to = Number(to || 0);
    if (reduce || !to) { el.textContent = fmt(to); return; }
    var t0 = performance.now();
    (function step(t) { var p = Math.min(1, (t - t0) / ms); el.textContent = fmt(Math.round(to * (1 - Math.pow(1 - p, 3)))); if (p < 1) requestAnimationFrame(step); })(t0);
  }
  function onLive(fn) { if (live) fn(live); listeners.push(fn); }
  function load() {
    fetch(HUB, { headers: { accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.ok && d.club && d.week) { live = d; listeners.forEach(function (fn) { fn(d); }); } })
      .catch(function () {});
  }

  /* ---------- Walk-in (home page, once per visit) ---------- */
  function heroGo() { html.classList.add("dc-hero-go"); }
  function entry() {
    var isHome = doc.body.classList.contains("index");
    var seen = false; try { seen = sessionStorage.getItem("dc-entered") === "1"; } catch (e) {}
    if (!isHome || editor || seen || /[?&]noentry\b/.test(location.search) || location.hash.length > 1) { heroGo(); return; }
    var items = []; try { items = JSON.parse((doc.getElementById("dc-entry-data") || {}).textContent || "[]"); } catch (e) {}
    var gate = doc.createElement("div");
    gate.className = "dc dc-entry dc-entry--store"; gate.setAttribute("role", "dialog"); gate.setAttribute("aria-label", "Entering the Discipline Club store");
    var ap = items.filter(function (p) { return p.l !== "DC Fuel"; }), fu = items.filter(function (p) { return p.l === "DC Fuel"; }), mix = [];
    while (ap.length || fu.length) { if (ap.length) mix.push(ap.shift()); if (fu.length) mix.push(fu.shift()); }
    var tiles = mix.slice(0, 5).map(function (p, n) {
      return '<figure class="dc-entry__p" style="animation-delay:' + (0.9 + n * 0.12).toFixed(2) + 's"><img src="' + esc(p.i) + '" alt="' + esc(p.t) + '" decoding="async"><figcaption>' + esc(p.l) + "</figcaption></figure>";
    }).join("");
    gate.innerHTML = '<div class="dc-entry__door dc-entry__door--l"></div><div class="dc-entry__door dc-entry__door--r"></div>' +
      '<div class="dc-entry__in"><p class="dc-entry__mark"><b>DISCIPLINE</b> <span>CLUB</span></p>' +
      '<p class="dc-entry__live">The Club Store</p>' +
      '<p class="dc-entry__big">The <span>Uniform</span></p><p class="dc-entry__sub">of the disciplined man.</p>' +
      (tiles ? '<div class="dc-entry__shelf">' + tiles + "</div>" : "") +
      '<div class="dc-entry__line"><i></i></div>' +
      '<p class="dc-entry__stats"><span>Club Issue</span><i></i><span>DC Training</span><i></i><span>DC Fuel</span></p>' +
      '<p class="dc-entry__now" data-e="now" aria-live="polite"></p><button type="button" class="dc-entry__go">Enter the Store</button></div>';
    html.classList.add("dc-entering");
    doc.body.insertBefore(gate, doc.body.firstChild);
    var opened = false;
    function open() {
      if (opened) return; opened = true;
      try { sessionStorage.setItem("dc-entered", "1"); } catch (e) {}
      gate.classList.add("is-open"); html.classList.remove("dc-entering"); heroGo();
      setTimeout(function () { gate.remove(); }, reduce ? 50 : 1300);
    }
    gate.querySelector(".dc-entry__go").addEventListener("click", open);
    doc.addEventListener("keydown", function k(e) { if (e.key === "Escape" || e.key === "Enter") { open(); doc.removeEventListener("keydown", k); } });
    setTimeout(function () { gate.querySelector(".dc-entry__go").focus({ preventScroll: true }); }, 60);
    onLive(function (d) {
      if (opened || !d.club.men_active) return;
      var el = gate.querySelector('[data-e="now"]');
      el.innerHTML = "Worn by <b>" + fmt(d.club.men_active) + "</b> men in the Club." + (d.shirts && d.shirts.earned_total ? " <b>" + fmt(d.shirts.earned_total) + "</b> Goal Shirts earned. Never sold." : "");
      el.classList.add("in");
    });
    setTimeout(open, reduce ? 1200 : 4500);
  }

  /* ---------- Live strip ---------- */
  function strip() {
    var s = doc.querySelector("[data-dc-live-strip]"); if (!s) return;
    var msg = s.querySelector("[data-dc-live-msg]"), cnt = s.querySelector("[data-dc-live-count]"), t = null;
    onLive(function (d) {
      var lines = newest(d.activity).slice(0, 10).map(function (a) { return "<b>" + esc(a.man) + "</b>" + esc(a.did) + (a.at ? "<time>" + esc(ago(a.at)) + "</time>" : ""); });
      lines.splice(1, 0, "<b>" + fmt(d.club.lbs_lost_current_men) + " lbs</b>lost by the men in the Club right now");
      if (cnt) cnt.innerHTML = "<b>" + fmt(d.club.men_active) + "</b> men in the Club";
      var i = 0;
      function show() { msg.innerHTML = lines[i++ % lines.length]; msg.classList.remove("in"); void msg.offsetWidth; msg.classList.add("in"); }
      if (t) clearInterval(t); show(); if (!reduce) t = setInterval(show, 3800);
      s.hidden = false;
    });
  }

  /* ---------- Live shirt count ---------- */
  function shirts() {
    var els = doc.querySelectorAll("[data-dc-live-shirts]"); if (!els.length) return;
    onLive(function (d) {
      var n = d.shirts && d.shirts.earned_total; if (!n) return;
      Array.prototype.forEach.call(els, function (el) { el.hidden = false; countUp(el.querySelector("b"), n, 1200); });
    });
  }

  /* ---------- Results slider ---------- */
  function slider() {
    var root = doc.querySelector("[data-dc-ts]"); if (!root) return;
    var data = []; try { data = JSON.parse(root.querySelector("script[type='application/json']").textContent); } catch (e) { return; }
    if (!data.length) return;
    var MS = 4500, i = 0, playing = !reduce, hold = false, seen = true, tm = null;
    var frame = root.querySelector(".dc-ts__frame"), info = root.querySelector(".dc-ts__info"), bar = root.querySelector(".dc-ts__bar i");
    var rail = root.querySelector(".dc-ts__rail"), stage = root.querySelector(".dc-ts__stage"), pp = root.querySelector("[data-pp]");
    rail.innerHTML = data.map(function (m, n) { return '<button type="button" role="tab" aria-label="' + esc(m.n + ", down " + m.l + " lbs") + '" data-i="' + n + '"><img src="' + esc(m.t) + '" alt="" loading="lazy" decoding="async" draggable="false"><span>' + m.l + "</span></button>"; }).join("");
    function render() {
      var m = data[i];
      frame.querySelector("img") && frame.querySelector("img").remove();
      var img = doc.createElement("img"); img.src = m.s; img.alt = m.n + ", " + m.r + ", before and after, down " + m.l + " pounds"; img.draggable = false; img.decoding = "async";
      frame.insertBefore(img, frame.firstChild);
      info.querySelector(".dc-ts__count").innerHTML = "<b>" + String(i + 1).padStart(2, "0") + "</b> / " + data.length;
      var res = info.querySelector(".dc-ts__result"); res.innerHTML = "<small>Down</small><span>0</span><small>lbs</small>"; res.classList.remove("dc-ts__anim"); void res.offsetWidth; res.classList.add("dc-ts__anim");
      countUp(res.querySelector("span"), m.l, 700);
      var nm = info.querySelector(".dc-ts__name"); nm.textContent = m.n; nm.classList.remove("dc-ts__anim"); void nm.offsetWidth; nm.classList.add("dc-ts__anim");
      info.querySelector(".dc-ts__role").textContent = m.r;
      Array.prototype.forEach.call(rail.children, function (b, n) { b.classList.toggle("on", n === i); b.setAttribute("aria-selected", n === i); });
      var on = rail.children[i]; if (on) rail.scrollTo({ left: on.offsetLeft - rail.clientWidth / 2 + on.clientWidth / 2, behavior: reduce ? "auto" : "smooth" });
      [1, -1].forEach(function (k) { var x = new Image(); x.src = data[(i + k + data.length) % data.length].s; });
      tick();
    }
    function go(n) { i = (n % data.length + data.length) % data.length; render(); }
    function tick() {
      if (tm) clearTimeout(tm);
      var run = playing && !hold && seen;
      bar.className = ""; bar.style.animationDuration = MS + "ms"; void bar.offsetWidth; if (run) bar.className = "run";
      if (run) tm = setTimeout(function () { go(i + 1); }, MS);
      if (pp) { pp.textContent = playing ? "II" : "▶"; pp.setAttribute("aria-label", playing ? "Pause slideshow" : "Play slideshow"); }
    }
    root.querySelector(".dc-ts__prev").onclick = root.querySelector("[data-prev]").onclick = function () { go(i - 1); };
    root.querySelector(".dc-ts__next").onclick = root.querySelector("[data-next]").onclick = function () { go(i + 1); };
    if (pp) pp.onclick = function () { playing = !playing; tick(); };
    rail.addEventListener("click", function (e) { var b = e.target.closest("button"); if (b) go(+b.getAttribute("data-i")); });
    stage.addEventListener("mouseenter", function () { hold = true; tick(); });
    stage.addEventListener("mouseleave", function () { hold = false; tick(); });
    stage.addEventListener("keydown", function (e) { if (e.key === "ArrowRight") go(i + 1); if (e.key === "ArrowLeft") go(i - 1); });
    var sx = null, sy = 0;
    stage.addEventListener("pointerdown", function (e) { sx = e.clientX; sy = e.clientY; });
    stage.addEventListener("pointerup", function (e) { if (sx == null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1)); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { seen = es[0].isIntersecting; tick(); }, { threshold: .25 }).observe(root);
    doc.addEventListener("visibilitychange", function () { seen = !doc.hidden; tick(); });
    render();
  }

  /* ---------- Scroll reveals ---------- */
  function reveals() {
    if (editor || reduce || !("IntersectionObserver" in window)) return;
    var els = doc.querySelectorAll(".dc-section .dc-wrap > *, .dc-three .dc-wrap > *, .dc-signup");
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }); }, { threshold: .12, rootMargin: "0px 0px -6% 0px" });
    Array.prototype.forEach.call(els, function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight) return; el.classList.add("dc-rv"); io.observe(el); });
  }

  function start() { entry(); strip(); shirts(); slider(); reveals(); load(); setInterval(load, 60000); }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", start); else start();
})();
